import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../../headerone/Main";
import Breadcrumb from "../../Breadcrumb/Main";
import { Container, Row, Col, Table } from "react-bootstrap";


function Main(props) {
    
    const [activeIndex, setActiveIndex] = useState(props.activeIndex);

    const handleToggle = (index) => {
       
        setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
    };

    const InternsApprentice = 

    [
        
    

        {
            AdvertisementDate: <> 01.02.2025 </>,
            NameofthePost: <>Graduate Apprentice (19 Positions)<br/><br/>Technician (Diploma Apprentice) (07 Positions)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTP_APPRENTICESHIP_25-26_01.pdf",
                Text: "Advertisement for 1-year Apprenticeship Training Programme for Graduate/Diploma under NATS",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://docs.google.com/forms/d/e/1FAIpQLSc9FtrjTGsgJEBZ2pnEf4cRjpNxN7L3VxWgQxcoojDQYHASoQ/viewform",
                    Text: "Online application form",
                    glowstatus : "yes"   
                }

            ],
            LastDate: <>Last date for submission of application : 28.02.2025</>,
            Status:[
                 {
                Link: "",
                Text: <></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
          

        {
            AdvertisementDate: <> 14.10.2024 </>,
            NameofthePost: "Library Information Assistant - Interns (04 Positions)",
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/IITTLIB-INTERNAdvt.2024-2501_Notification_Library_Information_Assistant_Interns.pdf",
                Text: "Notification for the position of Library Information Assistant - Interns for Central Library",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://docs.google.com/forms/d/e/1FAIpQLSenRZrFqoIJObPiEgNndFDLmbtpIFFvccMtxw_qgsYxSx3lrA/viewform",
                    Text: "Online application is closed",
                    glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 30.10.2024 <br /><br />Tentative date of selection process : <s>20.11.2024</s> 29.11.2024</>,
            Status:
            [ 
            {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/ITTLIB-INTERNAdvt.2024-2501_Library_Intern_Selected_List_2024_25.pdf",
                Text: "Selected Candidates List",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                },
                glowstatus: "yes"
            },
            {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/IITTLIB-INTERNAdvt.2024-2502_Lib_Interns_SL_and_NSL.pdf",
                Text: "Provisionally Shortlisted and Not Shortlisted Candidates List",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
   
        {
            AdvertisementDate: <> 31.10.2023 </>,
            NameofthePost: "Library Information Assistant - Interns (05 Positions)",
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2023/IITTPLIBINTERNAdvt.2023-2401.pdf",
                Text: "Notification for the position of Library Information Assistant - Interns for Central Library",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 15.11.2023 <br /><br />Tentative date of selection process : 29.11.2023</>,
            Status:[
                 {
                Link: "https://files.iittp.ac.in/pdfs/announcements//2023/IITTPLIBINTERNAdvt%202023-2401_Result.pdf",
                Text: <>Selected Candidates List<br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2023/IITTPLIBInterns2023-2404_Short%20listed_LIA_Interns_2023.pdf",
                Text: "Provisionally Shortlisted and Not Shortlisted Candidates List",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 01.09.2023 </>,
            NameofthePost: <>Graduate Apprentice (09 Positions)<br/><br/>Technician (Diploma Apprentice) (07 Positions)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2023/Apprenticeship/Advt.%20No.%20IITTPAPPRENTICESHIP202301_Apprenticeship_Advertisement.pdf",
                Text: "Advertisement for 1-year Apprenticeship Training Programme for Graduate/Diploma under NATS",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2023/Apprenticeship/Apprenticeship%20Annexure-A.pdf",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : Extended till 03.10.2023</>,
            Status:[
                 {
                Link: "https://files.iittp.ac.in/pdfs/announcements//2023/Apprenticeship_Selection_Result.pdf",
                Text: <>Selected Candidates List<br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2023/Apprenticeship%20shortlisted%20&%20Not%20shortlisted%20Candiates.pdf",
                Text: "Provisionally Shortlisted Candidates List",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        }
          

        

    ]


   
    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Internship and Apprenticeship" />
            <section className="project-detail">
                <div className="container">
                    <div className="c-heading">
                        <h1>Internship and Apprenticeship</h1>
                    </div>

                    <Row>
                        <div className="card-body">

                            
                                    <Table bordered responsive className="mt-3 table table-striped">
                                    <thead>
                                        <tr className='c-tablehead'>
                                        <th>
                                        Date
                                            </th>
                                            <th>
                                                Name of the Post
                                            </th>
                                            <th>Advertisement</th>
                                            <th>
                                                Application
                                            </th>
                                            <th>
                                                Last Date
                                            </th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                    
                                    <tbody>
                                        {InternsApprentice.map((item, index) => (
                                            <tr key={index}>
                                                 <td>{item.AdvertisementDate}</td>
                                                <td>{item.NameofthePost}</td>
                                                <td>
                                                    {typeof item.Advertisement === 'string' ? item.Advertisement : (
                                                       
                                                        
                                                        <a href={item.Advertisement.Link} style={{ color: (item.Advertisement.Style && item.Advertisement.Style.color) }} target="_blank" >
                                                            {item.Advertisement.Text} 
                                                            <span> (Click Here <i className="icon fas fa-file-pdf" style={{color:"red"}}></i>)</span>
                                                        </a>
                                                   
                                                    )}
                                                </td>
                                                <td>
                                                    {item.Application.map((status, i) => (
                                                        <div key={i}>
                                                            <a className={`text-maroon ${status.glowstatus === "yes" ? 'glowing-text' : ''}`} href={status.Link} target="_blank" >{status.Text}</a>
                                                        </div>
                                                    ))}
                                                </td>
                                                <td><span><i className="icon fas fa-calendar" style={{color:"steelblue"}}> </i> </span>{item.LastDate}</td>
                                                <td>
                                                    {Array.isArray(item.Status) ? (
                                                        item.Status.map((status, idx) => (
                                                            <div key={idx}>
                                                                <a className={`text-maroon ${status.glowstatus === "yes" ? 'glowing-text' : ''}`} href={status.Link} style={{ color: (status.color || (status.Style && status.Style.color)) }} target="_blank" >
                                                                {status.Text}
                                                                </a>
                                                            </div>
                                                        ))
                                                    ) : (
                                                            <a className={`text-marron ${item.Status.glowstatus == "yes" ? 'glowing-text' : ''}`} href={item.Status.Link} style={{ color: (item.Status.Style && item.Status.Style.color) }} target="_blank" >
                                                            {item.Status.Text}
                                                        </a>
                                                    )
                                                    
                                                    }
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                            
                                    </Table>     
                        </div>
   
                    </Row>
                </div>
            </section>
        </>
    );
}

export default Main;
